import axios from 'axios'
import React, { Fragment } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { Row, Button, Col, Modal, Container, OverlayTrigger, Tooltip, Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'


const GrillaBusqueda = ({setListaGrilla, listaGrilla}) => {
  const [show, setShow] = useState(false)
 
  
  const data_modal_contacto = useSelector((state) => state.modalContactoTerceroReducer)
  const { cfg_form15,comboModoContactoModal, grillaHistorial} = data_modal_contacto
  const data_traza_modal = useSelector((state) => state.trazabilidadReducer)
  const {cfg_form18,respuestaGrillaBusqueda} = data_traza_modal

 useEffect(()=>{
  setListaGrilla(respuestaGrillaBusqueda && respuestaGrillaBusqueda.respuestaGrillaBusqueda)
 },[respuestaGrillaBusqueda])
 useEffect(()=>{
  setListaGrilla('')
 },[])
 const obtenerColumnas = () => {
  return [
    
    
    {
      dataField: 'glosaHito',
      text:cfg_form18 ? cfg_form18.cfg_form18[
        'seguimientohitos-grilla-hito'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: 'glosaTipoGestion',
      text: cfg_form18 ? cfg_form18.cfg_form18[
        'seguimientohitos-grilla-gestion'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: 'glosaAmbitoGestion',
      text:cfg_form18 ? cfg_form18.cfg_form18[
        'seguimientohitos-grilla-ambito'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: 'fechaHitoFormat',
      text: cfg_form18 ? cfg_form18.cfg_form18[
        'seguimientohitos-grilla-fechaocurre'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    
    {
      dataField: 'comentario',
      text: cfg_form18 ? cfg_form18.cfg_form18[
        'seguimientohitos-grilla-comentario'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      },
      formatter:(cell, row)=>{
        if(cell?.length>30) {
          return <>        
              <a href='#' style={{textDecoration:'none'}} onClick={(e)=>{
                 e.preventDefault()
                alert(cell)}}>{cell?.substring(0,30)}</a>
                
          </>
         }else{
             return cell
         }
       }
    },
    
    {
      dataField: 'usuario',
      text: cfg_form18 ? cfg_form18.cfg_form18[
        'seguimientohitos-grilla-usuario'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    
    {
      dataField: 'fechaRegistroHitoFormat',
      text: cfg_form18 ? cfg_form18.cfg_form18[
        'seguimientohitos-grilla-fecharegistro'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    
   
  ]
}
const handleShow=(row)=>{
  console.log(row.folioCarga)
}
  return (
    <>
     
      <Container>
      
      <Row className='mt-4 mb-3'>
          <Col>
            <ToolkitProvider
                search
                bootstrap4
                keyField='secuencia'
                data={listaGrilla ? listaGrilla : []}
                columns={obtenerColumnas()}
                defaultSorted={[{ dataField: 'secuencia', order: 'asc' }]}
               
                >
                {(props) => (
                    <div>
                   <Row>
                     <Col  className="d-grid gap-2 d-md-flex justify-content-md-end mt-2 mb-2">
                     
                   <Form.Control placeholder="Buscar en la grilla" className="w-25" onChange={(e) => { props.searchProps.onSearch(e.target.value) }}/>
                     </Col>
                   </Row>   

                    <BootstrapTable
                        {...props.baseProps}
                        bordered={false}
                        headerWrapperClasses='table-secondary'
                        pagination={paginationFactory({ sizePerPage: 5})}
                        noDataIndication={
                        <div className='text-center'>
                            No hay registros encontrados
                        </div>
                        }
                    />
                    </div>
                )}
            </ToolkitProvider>
          </Col>
      </Row>
      </Container>
    </>
  )
}

export default GrillaBusqueda
